import adminReducer from "@/components/permissions/admin/ducks/reducer"
import internalReducer from "@/components/permissions/internal/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const permissionsReducer = combineReducers({
  admin: adminReducer,
  internal: internalReducer,
})

export default permissionsReducer
